import { PaletteType, Theme } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

const getDesignTokens = (type: PaletteType) =>
  ({
    palette: {
      type,
      primary: {
        main: '#26c485',
        contrastText: '#111',
      },
      secondary: {
        main: '#3f51b5',
        contrastText: '#000',
      },
      error: {
        main: red.A400,
      },
      ...(type === 'light'
        ? // Palette for light mode
          {
            background: {
              paper: '#eceef8',
              default: '#3f51b510',
            },
            action: {
              hover: '#edf0f3',
            },
            divider: '#dae0e6',
            text: {
              primary: '#011936',
              secondary: '#52647a',
              disabled: '#91a1b6',
            },
            success: {
              main: '#198057',
            },
          }
        : // Palette for dark mode
          {
            background: {
              paper: '#212121',
              default: '#292929',
            },
            action: {
              hover: '#262f39',
            },
            divider: '#5b6f89',
            text: {
              primary: '#e3e3e3',
              secondary: '#999999',
              disabled: '#5b6f89',
            },
            success: {
              main: '#24bb7f',
            },
          }),
    },
    typography: {
      fontFamily: "'Poppins', sans-serif",
    },
    overrides: {
      MuiTypography: {
        root: {
          cursor: 'text',
        },
      },
    },
  } as Partial<Theme>);

export default getDesignTokens;
